import { useState, useEffect } from 'react'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import TabChooser from './TabChooser'
import InstallationAuditsTable from '../components/tables/InstallationAuditsTable'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import { AuditContextProvider } from '../../global/context/audit-context/AuditContext'
import DvirAuditsTable from '../components/tables/DvirAuditsTable'
import CoachingAuditsTable from '../components/tables/CoachingAuditsTable'
import AITrainingTable from '../components/tables/AITrainingTable'
import VanDownAuditsTable from '../components/tables/VanDownAuditsTable'
import CleanlinessTable from '../components/tables/CleanlinessTable'
import { AUDIT_KEYS } from '../../global/constants/audit'
import MessageIcon from '@mui/icons-material/Message'
import MessageModal from '../components/technician-messaging/MessageModal'
import ReportVanDownModal from '../components/report-van-down-modal/ReportVanDownModal'
import styles from './styles.module.css'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
export interface ILocationFilters {
  locationFilter: string
  setLocationFilter: Function
}

interface IAuditsMainProps {
  tabType: AUDIT_KEYS
}

function AuditsMain({ tabType }: IAuditsMainProps) {
  const [refetchIndex, setRefetchIndex] = useState(0)
  const [locationFilter, setLocationFilter] = useState('')
  const [messageModalOpen, setMessageModalOpen] = useState(false)
  const [reportVanDownModalOpen, setReportVanDownModalOpen] = useState(false)

  let table: React.ReactElement | null = null

  const showLocationDropdown = [
    AUDIT_KEYS.coaching,
    AUDIT_KEYS.vanDown,
    AUDIT_KEYS.cleanliness,
  ].includes(tabType)
  const showMessageButton = tabType === AUDIT_KEYS.dvir
  const showReportVanDownButton = tabType === AUDIT_KEYS.vanDown

  useEffect(() => {
    setLocationFilter('')
  }, [tabType])

  switch (tabType) {
    case AUDIT_KEYS.installation:
      table = (
        <InstallationAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.dvir:
      table = (
        <DvirAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.coaching:
      table = (
        <CoachingAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.aiTraining:
      table = <AITrainingTable />
      break
    case AUDIT_KEYS.vanDown:
      table = (
        <VanDownAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.cleanliness:
      table = (
        <CleanlinessTable
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
  }

  return (
    <AuditContextProvider>
      <MainPageWrapper
        title='Audits'
        titleFields={
          <>
            {showLocationDropdown && (
              <div style={{ marginRight: 'auto', marginLeft: '1rem' }}>
                <LocationDropDown
                  onLocationChange={(val: string) => {
                    setLocationFilter(val)
                  }}
                />
              </div>
            )}
            {showMessageButton && (
              <div style={{ marginLeft: 'auto' }}>
                <PrimaryButton
                  buttonName='Technician Messages'
                  onClick={() => setMessageModalOpen(true)}
                  children={
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <MessageIcon style={{ marginRight: '8px' }} />
                      {'Technician Messages'}
                    </div>
                  }
                />
              </div>
            )}
            {showReportVanDownButton && (
              <div style={{ marginLeft: 'auto' }}>
                <button
                  className={styles.buttonPrimary}
                  onClick={() => setReportVanDownModalOpen(true)}
                >
                  Report Van Down
                </button>
              </div>
            )}
          </>
        }
      >
        <TabChooser />
        {table}
        <MessageModal
          open={messageModalOpen}
          onClose={() => setMessageModalOpen(false)}
        />
        <ReportVanDownModal
          isOpen={reportVanDownModalOpen}
          onClose={() => setReportVanDownModalOpen(false)}
          refetchTable={() => setRefetchIndex(refetchIndex + 1)}
        />
      </MainPageWrapper>
    </AuditContextProvider>
  )
}

export default AuditsMain
